// // // //
// The MCP clients we show setup instructions for on `/tools/mcp`.
//
// Two auth models coexist here:
//   - "oauth"   → Claude custom connector (client ID + secret).
//   - "api-key" → Claude Code / Cursor / Codex Desktop (an `sk-rwa-` API key
//                 in a Bearer header). These reuse the existing `api_keys`
//                 system.

export type McpClientId = "claude" | "claude-code" | "codex-desktop" | "cursor";

export type McpClientAuth = "oauth" | "api-key";

export interface McpClientMeta {
    id: McpClientId;
    label: string;
    auth: McpClientAuth;
}

export const MCP_CLIENTS: readonly McpClientMeta[] = [
    { id: "claude", label: "Claude", auth: "oauth" },
    { id: "claude-code", label: "Claude Code", auth: "api-key" },
    { id: "cursor", label: "Cursor", auth: "api-key" },
    { id: "codex-desktop", label: "Codex Desktop", auth: "api-key" },
] as const;

export const DEFAULT_MCP_CLIENT: McpClientId = "claude";

export function getMcpClient(id: McpClientId): McpClientMeta {
    // `id` is a union of exactly the ids in MCP_CLIENTS, so this always matches.
    return MCP_CLIENTS.find((client) => client.id === id) ?? MCP_CLIENTS[0];
}

// // // //
// The credential returned by the connect wizard, shaped per auth model. The
// `kind` discriminant lets the connect step pick the right instructions.

export type McpCredential =
    | {
          kind: "oauth";
          clientId: string;
          clientSecret: string;
          name: string;
      }
    | {
          kind: "api-key";
          key: string;
          name: string;
      };

/** Placeholder API key shown before the user generates a real one (copy off). */
export const PLACEHOLDER_API_KEY = "sk-rwa-xxxxxxxx";
